import { render, staticRenderFns } from "./ProfilePageMenuItem.vue?vue&type=template&id=139c7a26&scoped=true&"
import script from "./ProfilePageMenuItem.vue?vue&type=script&lang=ts&"
export * from "./ProfilePageMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProfilePageMenuItem.vue?vue&type=style&index=0&id=139c7a26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139c7a26",
  null
  
)

export default component.exports